import axios from "axios";

axios.defaults.baseURL = "https://api.mehfil.aaibuzz.com/api";
